import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { PfuLogo } from "../components/Logo";
import { useAuth } from "../auth";
import { apiError } from "../api";
import { Spinner } from "../components/ui";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.has_access ? "/dashboard" : "/pricing");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md fade-in">
        <div className="flex items-center gap-2.5 mb-6">
          <PfuLogo size={40} />
          <div>
            <div className="font-display font-bold text-xl text-ink leading-none">PFU Tracker</div>
            <div className="text-xs text-muted mt-1">Mauritius price watch</div>
          </div>
        </div>

        <p className="text-[15px] text-muted mb-6 leading-relaxed">
          Track regulated products from Mauritius' official Price Fixing Unit catalogues and get
          alerted the moment a maximum retail price changes.
        </p>

        <form onSubmit={submit} className="card p-6 space-y-4" data-testid="login-form">
          <h1 className="font-display text-2xl text-ink">Sign in</h1>
          <div>
            <label className="label" htmlFor="email">Email</label>
            <input id="email" type="email" required className="input" value={email}
              onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              autoComplete="email" placeholder="you@example.com" />
          </div>
          <div>
            <label className="label" htmlFor="password">Password</label>
            <div className="relative">
              <input id="password" type={show ? "text" : "password"} required className="input pr-11"
                value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password" autoComplete="current-password" placeholder="••••••••" />
              <button type="button" onClick={() => setShow((s) => !s)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted"
                data-testid="login-toggle-password"
                aria-label={show ? "Hide password" : "Show password"}>
                {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>
          {error && <p className="text-sm text-rose" data-testid="login-error">{error}</p>}
          <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="login-submit">
            {loading && <Spinner />} Sign in
          </button>
        </form>

        <p className="text-sm text-muted text-center mt-5">
          No account?{" "}
          <Link to="/signup" className="text-teal font-medium" data-testid="link-signup">Create one</Link>
        </p>
      </div>
    </div>
  );
}
